var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-quagga',{attrs:{"onDetected":_vm.logIt,"readerTypes":['code_39_reader','code_39_vin_reader','code_128_reader','code_93_reader'],"readerSize":_vm.readerSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }